<template>
  <div class="questionsContainer">
    <div class="w-full h-[4vw]">
      <img src="../assets/icons/spacecraftIcon.svg" alt="Kaffea Terra spacecraft"
           class="w-[10vw] relative left-[10%]">
    </div>
    <div class="title">
      <p>{{ $t('questionSecPage.firstPartQuestion') }}</p>
      <p>{{ $t('questionSecPage.SeqPartQuestion') }}</p>
    </div>
    <div class="flex flex-col gap-[3vw] w-full">
      <template v-if="answers.question1 === 'Αμερική'">
        <button
            :class="{ selected: isSelected('Σοκολάτα & Ξηροί Καρποί', 'Brazil') }"
            @click="selectAnswer('Σοκολάτα & Ξηροί Καρποί', 'Brazil')"
        >
          {{ $t('questionSecPage.AmericaAnswer') }}
        </button>
        <button
            :class="{ selected: isSelected('Καραμέλα & Σταφίδες', 'Colombia') }"
            @click="selectAnswer('Καραμέλα & Σταφίδες', 'Colombia')"
        >
          {{ $t('questionSecPage.AmericaAnswer2') }}
        </button>
      </template>

      <template v-else-if="answers.question1 === 'Αφρική'">
        <button
            :class="{ selected: isSelected('Κόκκινα Φρούτα & Λουλούδια', 'Ethiopia') }"
            @click="selectAnswer('Κόκκινα Φρούτα & Λουλούδια', 'Ethiopia')"
        >
          {{ $t('questionSecPage.AfricanAnswer') }}
        </button>
        <button
            :class="{ selected: isSelected('Εσπεριδοειδή & Βατόμουρα', 'Kenya') }"
            @click="selectAnswer('Εσπεριδοειδή & Βατόμουρα', 'Kenya')"
        >
          {{ $t('questionSecPage.AfricanAnswer2') }}
        </button>
      </template>

      <template v-else-if="answers.question1 === 'Ασία'">
        <button
            :class="{ selected: isSelected('Μαύρη Σοκολάτα & Κεράσια', 'India') }"
            @click="selectAnswer('Μαύρη Σοκολάτα & Κεράσια', 'India')"
        >
          {{ $t('questionSecPage.AsiaAnswer') }}
        </button>
        <button
            :class="{ selected: isSelected('Τροπικά Φρούτα & Κόκκινο Κρασί', 'Papua New Guinea') }"
            @click="selectAnswer('Τροπικά Φρούτα & Κόκκινο Κρασί', 'Papua New Guinea')"
        >
          {{ $t('questionSecPage.AsiaAnswer2') }}
        </button>
      </template>
    </div>
    <div class="w-full flex flex-row justify-between">
      <img src="../assets/icons/dotIcon.svg" alt="Kaffea Terra star" class="w-[1vw] relative left-[10%]">
      <img src="../assets/icons/movingstarIcon.svg" alt="Kaffea Terra moving star" class="w-[12vw]">
    </div>
  </div>

  <div class="flex justify-end gap-[1vw] absolute bottom-0 w-full">
    <div @click="goToPreviousQuestion">
      <img src="@/assets/arrowleft.svg" alt="arrow-left" class="w-[5vw] h-[5vw]">
    </div>
    <div @click="goToNextStep">
      <img src="@/assets/arrowright.svg" alt="arrow-right" class="w-[5vw] h-[5vw]">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answers: Object,
  },
  data() {
    return {
      answer: this.answers.question2 || "",
      coffees: [
        {index: 1, name: "Brazil", image: "/coffees/BrazilCoffee.png"},
        {index: 2, name: "Colombia", image: "/coffees/ColombiaCoffee.png"},
        {index: 3, name: "Ethiopia", image: "/coffees/EthiopiaCoffee.png"},
        {index: 4, name: "India", image: "/coffees/IndiaCoffee.png"},
        {index: 5, name: "Kenya", image: "/coffees/KenyaCoffee.png"},
        {index: 6, name: "Papua New Guinea", image: "/coffees/PapuaNewGuineaCoffee.png"},
      ],
    };
  },
  methods: {
    selectAnswer(flavor, country) {
      this.answer = {flavor, country};
      const formattedCountry = country.replace(/\s/g, ""); // Remove spaces from the country name
      const formattedAnswer = {flavor, country: formattedCountry};
      this.$emit("update-answers", {...this.answers, question2: formattedAnswer});
      this.goToNextStep();
    },
    isSelected(flavor, country) {
      return this.answer.flavor === flavor && this.answer.country === country;
    },
    goToPreviousQuestion() {
      this.answer = ""; // Reset the answer to go back to the questionsContainer
      this.$emit("prev-step");
    },
    goToNextStep() {
      if (this.answer) {
        this.$emit('next-step');
      }
    }
  },
};
</script>


<style scoped>
.questionsContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 60px;
  overflow: hidden;
  padding-bottom: 15%;

  @media only screen and (max-width: 1000px) {
    gap: 50px;
  }
  @media only screen and (max-width: 750px) {
    gap: 30px;
  }
}

.title {
  text-align: center;
  font-size: 7vw;
  line-height: normal;
  color: #FFFFFF;
  text-transform: uppercase;
}

button {
  padding: 5px 40px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  background: #434B78;
  border: 1px solid #FFFFFF;
  border-radius: 99px;
  color: #FFFFFF;
  text-transform: uppercase;
  text-align: center;
  font-size: 5vw;
  line-height: normal;
}

button:hover {
  background-color: white;
  color: #101B53;
}

button.selected {
  background-color: white;
  color: #101B53;
  font-weight: bold;
  border-color: #101B53;
}

.coffee-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding-bottom: 15%;

}

.coffee-image-container {
  position: relative;
  display: flex;
  width: 70vw;
  height: 70vw;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  z-index: 3;

  &::after {
    content: "";
    width: 100%;
    height: 100%;
    background-image: url("@/assets/ellipse.svg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 1;
    position: absolute;
    z-index: 1;
    top: 10%
  }

  .coffee {
    z-index: 2;
    width: 35vw;
  }
}
</style>
